import { render, staticRenderFns } from "./PromoPending.vue?vue&type=template&id=f9e16e5c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9e16e5c')) {
      api.createRecord('f9e16e5c', component.options)
    } else {
      api.reload('f9e16e5c', component.options)
    }
    module.hot.accept("./PromoPending.vue?vue&type=template&id=f9e16e5c&", function () {
      api.rerender('f9e16e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Promo/view/PromoPending.vue"
export default component.exports